<script lang="ts">
    export let link = '';
    export let campaignId = '';
    export let companyId = '';

    const utmParams = `?utm_source=badge&utm_medium=perspective-badge&utm_campaign=${campaignId}&utm_term=${companyId}`;
    const badgeLink = `${link || 'https://perspective.co'}${utmParams}`;
</script>

<div class="relative">
    <a
        class="wrapper fixed bottom-3 right-3 z-50 box-border flex h-[46px] w-40 cursor-pointer items-center rounded-md bg-[#343435] py-[11px] px-[13px] font-ui no-underline"
        href={badgeLink}
        target="_blank"
        rel="noopener noreferrer"
    >
        <div class="flex content-start items-center">
            <img
                class="w-[25px]"
                src="https://perspective.imgix.net/assets/app/logo/64x64.png"
                alt="perspective logo"
            />
        </div>
        <div class="flex flex-grow flex-col items-center">
            <div class="text-xs text-white">Try for free!</div>
            <div class="flex items-center">
                <div class="text-[7px]">
                    <span role="img" aria-label="lightning bolt"> ⚡ </span>
                    ️
                </div>
                <div class="text-[8px] text-[#8e8e93]">by perspective</div>
            </div>
        </div>
        <div class="flex items-center justify-end">
            <svg
                width="8px"
                height="12px"
                viewBox="0 0 8 12"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs />
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <polygon
                        id="Shape"
                        fill="#FFFFFF"
                        points="1.41 0 0 1.41 4.58 6 0 10.59 1.41 12 7.41 6"
                    />
                </g>
            </svg>
        </div>
    </a>
</div>
